<template>
  <div id="Grid">
    <!-- <vue-bootstrap4-table  :rows="rows" :columns="columns" :config="config" :classes="classes" >
            <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
            </template>
            <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
            </template>
            <template slot="action-slot" slot-scope="props">
              <a v-if="IsMojazBtnGridEdite && IsDelete" href="javascript:;" class="mr-2 badge" @click="OnDelete(props.row); "><h6><span class="fa fa-trash-alt text-secondary hover-danger" ></span></h6></a>
              <a v-if="IsMojazBtnGridDelete && IsEditNew" href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.row);"><h6><span class="fa fa-marker text-secondary hover-warning" ></span ></h6></a>
              <a v-if="IsInformation" href="javascript:;" class="mr-2 badge" @click="OnInformation(props.row)"><h6><span class="fa fa-info text-secondary hover-info" ></span></h6></a>      
            </template>
      </vue-bootstrap4-table> -->

    <Bnp-Grid v-if="$store.state.renderComponentGrid" :Sotrable="true" :action="true" :propsColumn="columns" :propsRows="rows">
      <template slot="action-slot" slot-scope="props">
        <a v-if="IsMojazBtnGridEdite && IsDelete" href="javascript:;" class="mr-2 badge" @click="OnDelete(props.props)"
          ><h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6
        ></a>
        <a v-if="IsMojazBtnGridDelete && IsEditNew" href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)"
          ><h6><span class="fas fa-marker text-secondary hover-warning"></span></h6
        ></a>
        <a v-if="$route.name == 'TarifKarbaran' && props.props.Id != 1" href="javascript:;" class="mr-2 badge" @click="OnCopyGridColumnAsRahbar(props.props)" title="به روز رسانی ستون ها از راهبری سیستم"
          ><h6><span class="fad fa-copy text-secondary hover-warning"></span></h6
        ></a>
        <a v-if="$route.name == 'TarifKarbaran'" href="javascript:;" class="mr-2 badge" @click="SendSms(props.props)" title="ارسال پیامک"
          ><h6><span class="fad fa-sms text-secondary hover-warning"></span></h6
        ></a>
        <a v-if="IsInformation" href="javascript:;" class="mr-2 badge" @click="OnInformation(props.props)"
          ><h6><span class="fa fa-info text-secondary hover-info"></span></h6
        ></a>
      </template>
      <template v-if="$route.name == 'TarifKarbaran'" slot="Archive" slot-scope="props">
        <i v-if="!props.props.Archive" class="fas fa-check text-success"></i>
        <i v-else class="fas fa-times text-danger"></i>
      </template>
    </Bnp-Grid>
  </div>
</template>
<script>
import BnpGrid from '../../components/BnpGrid/BnpGrid'
import VueBootstrap4Table from 'vue-bootstrap4-table'
export default {
  data() {
    return {
      IsMojazBtnGridEdite: null,
      IsMojazBtnGridDelete: null,
      DataAxios_row: {
        ArryfildValue: '',
        Method: 'Get',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxois: { ArryfildValue: {}, Method: 'post', Action: 'ReadGridColumns' },
      rows: [],
      columns: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table ',
      },
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
      DataAxiosDelete: {
        ArryfildValue: '',
        Method: 'Delete',
        Action: this.$route.name,
        Token: this.$session.get('Token'),
      },
    }
  },
  props: {
    IsDelete: { type: Boolean, default: true },
    IsEditNew: { type: Boolean, default: true },
    IsInformation: { type: Boolean, default: true },
  },
  components: {
    VueBootstrap4Table,
    BnpGrid,
  },
  methods: {
    AcceessButton(RoutName) {
      var menuBtn = this.$session.get('Menu')
      var GetParentRoute = menuBtn.filter((z) => z.RouteName == RoutName)
      var ButtonsRoute = menuBtn.filter((z) => z.ParentId == GetParentRoute[0].id)
      this.$session.set(RoutName, ButtonsRoute)
    },
    OnDelete(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      this.DataAxiosDelete.ArryfildValue = { id: data.Id }
      this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
        if (result == true) {
          this.$store.state.renderComponentGrid = false
          var temparrayNum = this.rows.indexOf(this.rows.filter((x) => x.Id == data.Id)[0])
          this.rows.splice(temparrayNum, 1)
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        }
      })
    },
    OnEditNew(row) {
      this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', DataRow: row } })
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponent = true
      })
    },
    OnInformation(row) {
      console.log(row)
    },
    OnCopyGridColumnAsRahbar(row) {
      let DataAxios_Copycolumn = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'TarifKarbaran/b_CopySettingGrid',
        Token: this.$session.get('Token'),
      }
      DataAxios_Copycolumn.ArryfildValue.tblFromUserId = row.Id
      this.$PostData(DataAxios_Copycolumn)
        .then((data) => {
          if (data[0].ColDeleted == 'RowDeleted') {
            this.$toasted.success('چیدمان ستون های کاربر [ ' + row.NamFam + ' ] به روز شد', {
              action: {
                onClick: (e, toastObject) => {
                  toastObject.goAway(10000)
                },
              },
              duration: 1500,
            })
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'چیدمان ستون باخطا مواجه شد', 'warning', 2000)
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    SendSms(data) {
      // ["PerMobile", "PerName", "PerId", "CustomerId", "CustomerName","personel"]
      //   UserMobile Pss UserName PerMobile FullName
      this.$store.state.Customer = { Customer: { CodeBazaryabi: '1499', CustomerCode: '9999', CustomerName: 'برنامه نویسان نواندیش پاسارگاد' } }
      var smsParams = this.$router.push({
        name: 'CustomerSms',
        params: { PerMobile: data.UserMobile, PerName: data.NamFam, PerId: data.Id, CustomerId: 999, personel: { UserMobile: data.UserMobile, Pss: data.Pss, UserName: data.UserName, PerMobile: data.UserMobile, FullName: data.NamFam } },
      })
    },
  },
  created() {
    this.AcceessButton(this.$route.name)
  },
  beforeMount() {
    this.DataAxios_row.Action = this.$route.name
    this.$GetDataDefultGrid(this.DataAxios_row)
      .then((data) => {
        this.rows = data
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          // Add the component back in
          this.$store.state.renderComponentGrid = true
        })
      })
  },
  mounted() {
    this.DataAxois.ArryfildValue = { SoftwareId: 2, UserId: 1, FormName: 'frm' + this.$route.name, ShowView: 0 }
    this.$GetColumns(this.DataAxois, true)
      .then((data) => {
        let info
        let List = []
        for (let index = 0; index < data.length; index++) {
          info = data[index]
          List.push(info)
        }
        List.push({ label: 'عملیات ها', name: 'id', slot_name: 'action-slot', sort: false })
        this.columns = List
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          // Add the component back in
          this.$store.state.renderComponentGrid = true
        })
      })
    this.IsMojazBtnGridEdite = this.$session.get(this.$route.name)[1].isMojaz
    this.IsMojazBtnGridDelete = this.$session.get(this.$route.name)[2].isMojaz
  },
}
</script>
<style scoped></style>
